import './Form.css'

function Form({children, onSubmit, hasImage}) {
  if (!hasImage) {
    return (
      <form onSubmit={onSubmit} className='form-wrapper'>
          {children}
      </form>
    )
  } else {
    return (
      <form onSubmit={onSubmit} className='form-wrapper' encType='multipart/form-data'>
          {children}
      </form>
    )
  }
}

export default Form